module.exports = __webpack_public_path__ + "5225088eac3c980180a8822a85fdc7af.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/settings/vip.png
// module id = 316
// module chunks = 0